import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder} from "@angular/forms";
import {data} from "autoprefixer";
import {GetLanguage, HandleListName, HandleResponseError} from "../../shared/functions/shared-functions";
import {CoreService} from "../../services/core.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteComponent>,
              private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
              private toastr: ToastrService,
              private coreService: CoreService) {

  }

  rows = [];

  ngOnInit(): void {
    this.rows = [this.data?.rows];
  }

  remove(item) {
    this.rows = this.rows.filter(x => x.id !== item.id);
  }


  yes() {
    this.rows.forEach((item, index) => {
      const path = `${this.data.api}/${item.id}`
      this.coreService.deleteRequest(path).subscribe(res => {
        if (index === (this.rows?.length - 1)) {
          this.toastr.success(res?.message);
        }
      }, error => {
        this.toastr.error(HandleResponseError(error));
      }, () => {
        // console.log('in', index)
        // console.log('this.data?.rows?.length', this.rows?.length)
        if (index === (this.rows?.length - 1)) {
          this.dialogRef.close({deleted: this.rows});
        }
        // this.rows = this.rows.filter(x => x.id !== item.id);
      })
    })

  }
}
